import { Alertcondition } from "@/models/alertcondition";
import { Pagination } from "@/models/pagination";
import { IAlertcondition, AlertconditionState } from "@/types/alertcondition";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<AlertconditionState, IAlertcondition> = {
  single: (state, single) => {
    state.single = new Alertcondition(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Alertcondition(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Alertcondition();
    state.pagination = new Pagination();
  },
};

export default mutations;
